import { render, staticRenderFns } from "./formBlock.vue?vue&type=template&id=d56fb8f8"
import script from "./formBlock.vue?vue&type=script&lang=js"
export * from "./formBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports